import React from 'react';

interface BackgroundImageProps {
  src: string;
  alt?: string;
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

const BackgroundImage: React.FC<BackgroundImageProps> = ({
  src,
  alt,
  className,
  children,
  style,
}) => {
  return (
    <div 
      className={`background-image ${className || ''}`}
      style={{
        backgroundImage: `url(${src})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        ...style,
      }}
      role="img"
      aria-label={alt}
    >
      {children}
    </div>
  );
};

export default BackgroundImage;